import styles from "./CMInfoSubtoolButtons.module.css";
import ShowScriptButton from "../../ShowScriptButton";
import StyledButton from "../../../common/buttons/StyledButton";
import classNames from "classnames";

const strings = {
  reset: "Reset",
  clear: "Clear",
  update: "Update",
};

type Props = {
  className?: string;
  onReset: () => void;
  isResetDisabled: boolean;
  onUpdate: () => void;
  isUpdateDisabled: boolean;
  isUpdateLoading: boolean;
} & (
  | {
      hideScriptButton: true;
      isScriptOpen?: never;
      onSetScriptOpen?: never;
    }
  | {
      hideScriptButton?: never;
      isScriptOpen: boolean;
      onSetScriptOpen: (open: boolean) => void;
    }
) &
  (
    | {
        hideClearButton: true;
        onClear?: never;
        isClearDisabled?: never;
      }
    | {
        hideClearButton?: never;
        onClear: () => void;
        isClearDisabled: boolean;
      }
  );

export default function CMInfoSubtoolButtons({
  className,
  hideScriptButton,
  isScriptOpen,
  onSetScriptOpen,
  onReset,
  isResetDisabled,
  hideClearButton,
  onClear,
  isClearDisabled,
  onUpdate,
  isUpdateDisabled,
  isUpdateLoading,
}: Props) {
  return (
    <div className={classNames(styles.buttonRow, className)}>
      {!hideScriptButton ? (
        <ShowScriptButton
          className={styles.scriptButton}
          showScript={isScriptOpen}
          onClick={() => onSetScriptOpen(!isScriptOpen)}
        />
      ) : null}
      <StyledButton
        variant="secondary"
        className={styles.button}
        preventDefaultDisabledStyles={true}
        onClick={onReset}
        disabled={isResetDisabled}
      >
        {strings.reset}
      </StyledButton>
      {!hideClearButton ? (
        <StyledButton
          variant="secondary"
          className={styles.button}
          preventDefaultDisabledStyles={true}
          onClick={onClear}
          disabled={isClearDisabled}
        >
          {strings.clear}
        </StyledButton>
      ) : null}
      <StyledButton
        variant="primary"
        className={styles.button}
        preventDefaultDisabledStyles={true}
        onClick={onUpdate}
        disabled={isUpdateDisabled}
        isLoading={isUpdateLoading}
      >
        {strings.update}
      </StyledButton>
    </div>
  );
}
